export default __webpack_public_path__ + "static/media/8360.2bd424a7.svg";